import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=555a963b&lang=pug&"
import script from "./Collection.vue?vue&type=script&lang=js&"
export * from "./Collection.vue?vue&type=script&lang=js&"
import style0 from "./Collection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('555a963b')) {
      api.createRecord('555a963b', component.options)
    } else {
      api.reload('555a963b', component.options)
    }
    module.hot.accept("./Collection.vue?vue&type=template&id=555a963b&lang=pug&", function () {
      api.rerender('555a963b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/domains/collection/Collection.vue"
export default component.exports